import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-card-bordered {
    border: none;

    .ant-card-body {
      padding: 0;
    }
  }
`

export const Card = styled.div`
  .ant-card-grid {
    width: 25%;
    height: 120px;
    background-color: ${props => props.$active === 'true' && '#e6f7ff'};
    border: ${props => props.$active === 'true' && '1px solid #1890ff'};
    padding: 16px;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: space-between;

    > .ant-typography-secondary {
      font-size: 12px;
      margin: 0 0 auto;
    }

    > .ant-typography-danger {
      text-align: end;
    }
  }
`
